import {combineReducers} from "redux";
import {loginReducer} from "./loginReducer";
import {pageReducer} from "./pageReducer";
import {adminReducer} from "./adminReducer";

export default combineReducers({
    loginReducer,
    adminReducer,
    pageReducer
})